/**
 * @module Widget
 */

import { Component, Input } from '@angular/core';
import { WidgetLayersClass } from '@class/widgetLayers.class';
import { UID } from '@models/uid.model';
import { ItemColor } from '@functions/item.functions';

@Component({
  selector: 'app-widget-layers-display-remaining',
  templateUrl: './widget-layers-display-remaining.component.html',
  styleUrls: ['./widget-layers-display-remaining.component.css']
})
export class WidgetLayersDisplayRemainingComponent {

  @Input() widgetLayers: WidgetLayersClass;
  @Input() current: UID;

  color = ItemColor('widgets');

  constructor() {}

  receiveValue(value: boolean) {
    this.widgetLayers.layer(this.current).change({ gaugeDisplayRemaining: value });
    if(this.widgetLayers.uid.value === this.current) this.widgetLayers.duplicateLayersOptions({ gaugeDisplayRemaining: value }, this.current);
  }

}
